import apiRequest from './api-request';
import { SniIndustryType } from '../types';

export const getAll = async (): Promise<SniIndustryType[]> => {
    try {
        const response = await apiRequest({
            method: 'GET',
            resource: 'sni'
        });
        return response;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching SNI list:', error);
        return [];
    }
};

export default getAll;
